import {LayerManagerV27} from '@volkswagen-onehub/layer-manager';
import {PageInfoServiceV1} from '@volkswagen-onehub/page-info-service';

export function createCloseTopLayerFunction(
  layerManager: LayerManagerV27,
  pageInfoService: PageInfoServiceV1
) {
  return (): void => {
    const layers = layerManager.getLayers();
    const topLayerIndex = layers.length - 1;
    // Early return if there are no layers to close
    if (topLayerIndex < 0) {
      return;
    }

    pageInfoService.setPageInfo();
    const topLayer = layers[topLayerIndex];
    topLayer.layer.close();
  };
}
